import { Component, OnInit } from '@angular/core';
import { Router, Event as RouterEvent, NavigationEnd } from '@angular/router';
import { MaintenanceService } from './authentication/helpers/maintenance.service';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { UpdateService } from './services/update.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, NgxUiLoaderModule],
})
export class AppComponent implements OnInit {
  public showHeader: any;
  //  Sets initial value to true to show loading spinner on first load
  public loading = true;
  public currentYear = new Date().getUTCFullYear();

  constructor(
    private readonly router: Router,
    private readonly maintenanceService: MaintenanceService,
    private readonly updateService: UpdateService) {
    this.showHeader = localStorage.getItem('userSession');
    router.events.subscribe((event: RouterEvent) => {
      this.showHeader = localStorage.getItem('userSession');
    });

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0);
    });
  }

  public ngOnInit() {
    this.maintenanceService.isMaintenance$.subscribe((isMaintenance) => {
      if (isMaintenance) {
        // Redirect to maintenance page if not already there
        if (this.router.url !== '/maintenance') {
          this.router.navigate(['/maintenance']);
        }
      }
    });
  }
}
